/**
 * Score bands, kept out of the component file so it exports only components.
 *
 * Three bands rather than a gradient: a recruiter reads "strong fit" faster
 * than a colour, and the exact number is right beside it for anyone who wants
 * to argue with the wording.
 */

const BANDS = [
  { from: 75, label: 'Strong fit', tone: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
  { from: 50, label: 'Fair fit', tone: 'bg-brand-50 text-brand-700 ring-brand-200' },
  { from: 0, label: 'Weak fit', tone: 'bg-amber-50 text-amber-800 ring-amber-200' },
];

export function bandFor(score) {
  return BANDS.find((band) => score >= band.from) ?? BANDS[BANDS.length - 1];
}
